export const formatMinutes = (minutes, hoursShorthand = ":") => {
	let hours = Math.floor(minutes / 60)
	let minutesLeft = minutes % 60
	return `${hours < 10 ? "0" : ""}${hours}${hoursShorthand}${
		minutesLeft < 10 ? "0" : ""
	}${minutesLeft}`
}
